import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import UpdatePage from '../../../composents/UpdatePage'
import CreatePage from '../../../composents/CreatePage'
import { CustomerClient } from './components/Client'
import { CustomerAccount } from './components/Account'
import { CustomerBank } from './components/Bank'

const title = 'Clients'
const headers = {
  icon: 'feather icon-edit',
  title: title,
  description: 'update of client',
  breadcrumbs: [
    {
      title: title,
      link: '/clients/clients',
    },
  ],
}

const STEPVALUE = {
  1: 'Client',
  2: 'Account',
  3: 'Bank',
  4: 'Credit Card',
}

function EditCustomer() {
  const [loader, setLoader] = useState(false),
    { id } = useParams(),
    [errors, setErrors] = useState({}),
    [city, setCity] = useState(null),
    [name, setName] = useState(''),
    [code, setCode] = useState(''),
    [cities, setCities] = useState([]),
    [entities, setEntities] = useState([]),
    [entity, setEntity] = useState(null),
    [account, setAccount] = useState({
      contacts: '',
      email: '',
      password: '',
      password_confirmation: '',
    }),
    [fail, setFail] = useState(false),
    [data, setData] = useState({}),
    [loading, setLoading] = useState(true),
    [bank, setBank] = useState({}),
    [note, setNote] = useState(),
    [step, setStep] = useState(1)

  async function onGet() {
    setLoading(true)
    let res = await resources.customer
      .readOne(id)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      setData(res.data)
      setCity({
        label: res.data.citys.name,
        value: res.data.citys.id,
      })

      setEntity({
        label: res.data.entity.name,
        value: res.data.entity.id,
      })

      setName(res.data.name)
      setCode(res.data.code)
      setNote(res.data?.description)

      setAccount({
        contacts: res.data.contacts,
        email: res.data.email,
      })

      setBank({
        bankName: res.data?.bankName,
        bankDetail: res.data?.bankDetail,
        benefName: res.data?.benefName,
        account: res.data?.account,
        swift: res.data?.swift,
      })
    } else if (res.status === 403) {
      setFail(true)
    }
    let cit = await resources.city
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })

    if (cit.status === 200) {
      let a = []
      cit.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.name,
          country: el.country.id,
        })
      })
      setCities(a)
    }

    let ent = await resources.entity
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })

    if (ent.status === 200) {
      let a = []
      ent.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.name,
          country: el?.city?.country?.id,
        })
      })
      setEntities(a)
    }

    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onUpdate(e) {
    e.preventDefault()
    setLoader(true)
    setErrors({})
    let formData = new FormData(e.target)
    let object = {
      ...account,
      ...bank,
      name,
      code_2: code || name.replace(/\s/g, '').slice(0, 5),
      ...Object.fromEntries(formData),
    }
    if (object?.password?.length === 0) {
      delete object.password
      delete object.password_confirmation
    }

    if (object?.code_2?.length === 0) {
      delete object.code_2
    }
    if (entity) object.HDEntity = entity.value
    if (city) object.city = city.value

    let res = await resources.customer
      .update(id, object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/clients/clients')
    } else if (res.status === 422) {
      const errors = res.data.errors.reduce((acc, error) => {
        return { ...acc, [error.field]: error.message }
      }, {})
      if ('code_2' in errors || 'name' in errors) {
        setStep(1)
      } else if (
        'contacts' in errors ||
        'email' in errors ||
        'password' in errors ||
        'password_confirmation' in errors
      ) {
        setStep(2)
      }
      setErrors(errors)
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterCity = () => {
    let all_cities = []
    if (entity) {
      all_cities = cities.filter((e) => e.country === entity.country)
    }
    return all_cities
  }

  const canGoToTheNextStep = () => {
    if (step === 1) {
      return entity === null || city === null || name.length === 0
    }

    if (step === 2) {
      return account?.contacts?.length === 0 || account?.email?.length === 0
    }

    return false
  }

  const OnAccountValueChange = (e) => {
    setAccount((items) => ({ ...items, [e.name]: e.value }))
  }

  const OnBankValueChange = (e) => {
    setBank((items) => ({ ...items, [e.name]: e.value }))
  }

  return (
    <CreatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
    >
      <form onSubmit={onUpdate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information about {STEPVALUE[step]}</h5>
              </div>
              <div className="card-body">
                {step === 1 && (
                  <CustomerClient
                    errors={errors}
                    name={name}
                    setName={setName}
                    cityFilter={filterCity()}
                    setCity={setCity}
                    entities={entities}
                    entity={entity}
                    setEntity={setEntity}
                    note={note}
                    city={city}
                    setNote={setNote}
                    code={code}
                    setCode={setCode}
                  />
                )}

                {step === 2 && (
                  <CustomerAccount
                    account={account}
                    errors={errors}
                    OnValueChange={OnAccountValueChange}
                  />
                )}

                {step === 3 && (
                  <CustomerBank errors={errors} bank={bank} OnValueChange={OnBankValueChange} />
                )}

                {step === 4 && (
                  <>
                    <Field
                      name="cardNumber"
                      defaultValue={data?.cardNumber}
                      error={errors['cardNumber']}
                      className="mb-3"
                    >
                      Card Number
                    </Field>
                    <Field
                      name="nameOnTheCard"
                      defaultValue={data?.nameOnTheCard}
                      error={errors['nameOnTheCard']}
                      className="mb-3"
                    >
                      Name on the card
                    </Field>
                  </>
                )}

                <div className="row ">
                  {step !== 1 && (
                    <div className="col-lg-6">
                      <div className="d-grid gap-2">
                        <Btn
                          class="btn waves-effect waves-light btn-primary"
                          onLoad={loader}
                          onClick={(e) => {
                            e.preventDefault()
                            setStep((value) => value - 1)
                          }}
                        >
                          <i className="feather icon-arrow-left"></i> Back
                        </Btn>
                      </div>
                    </div>
                  )}
                  <div className={`col-lg-${step === 1 ? '12' : '6'}`}>
                    <div className="d-grid gap-2">
                      <Btn
                        class="btn waves-effect waves-light btn-primary"
                        onLoad={loader}
                        onClick={(e) => {
                          if (step !== 4) {
                            e.preventDefault()
                            setStep((value) => value + 1)
                          }
                        }}
                        disabled={canGoToTheNextStep()}
                      >
                        <i
                          className={`feather ${step !== 4 ? 'icon-arrow-right' : 'icon-save'}`}
                        ></i>{' '}
                        {step !== 4 ? 'Next' : 'Submit'}
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </CreatePage>
  )
}

export default EditCustomer
